import { useState } from "react";
import Banner from "../components/Banner";
import RegisterCallout from "../components/RegisterCallout";
import VideoModal from "../components/VideoModal";

export default function PageVenue() {
  const [isOpen, setIsOpen] = useState(false);
  const [videoId, setVideoId] = useState(null);

  const openOverlay = (id) => {
    setVideoId(id);
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeOverlay = () => {
    setIsOpen(false);
    setVideoId(null);
    document.body.style.overflow = "auto";
  };
  return (
    <>
      <Banner
        leftImage="img/bg-banner-round-gradient.webp"
        rightImage="img/bg-banner-omni-la-costa.webp"
      >
        <div className="col-12 mb-3">
          <div className="display-1 color-white">
            Omni La Costa Resort & Spa
          </div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-5">
            FinComp '27 attendees can take advantage of an exclusive discounted
            room rate of $319 per night, plus taxes and fees. The deadline to
            access this discounted hotel rate is Friday, May 14, 2027 at 5:00
            p.m. PT.
          </p>
        </div>
        <div className="col-12">
          <a
            href="https://www.omnihotels.com/hotels/san-diego-la-costa"
            target="_blank"
            rel="noreferrer"
            className="btn-white-o me-4"
          >
            Hotel Website
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </a>
          <a
            href="https://bookings.omnihotels.com/event/san-diego-la-costa/fincomp-27-"
            target="_blank"
            rel="noreferrer"
            className="btn-white-o ms-4"
          >
            Book Your Stay
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </a>
        </div>
      </Banner>

      <section>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-10 px-0">
              <h1 className="small color-purple mb-4">
                Nestled in Carlsbad, California, just 35 miles north of downtown
                San Diego, Omni La Costa Resort & Spa offers an exceptional
                backdrop for FinComp 2027.
              </h1>
              <p>
                Come and enjoy world-class amenities, two championship golf
                courses, an award-winning spa, and several dining options just
                minutes from the Pacific Coast. With 400 lush acres to explore,
                including eight pools, five restaurants, a 9,100 sq. ft.
                Athletic Club, and multiple shops, there's plenty to discover
                well beyond the conference agenda.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6">
              <img
                className="img-fluid"
                src="./img/graphic-venue-resort.webp"
                alt="The Resort"
              />
            </div>
            <div className="col-4 px-0 offset-1">
              <h2 className="color-purple mb-3">The Resort</h2>
              <p>
                The Omni La Costa & Spa resort’s open-air courtyards, gardens,
                and four distinct pool areas provide a refreshing setting for
                relaxation between conference events, including an adults-only
                retreat with fire pits and a family pool with 100-foot
                waterslides. Partake in Southern California’s unique blend of
                relaxation, entertainment, and natural beauty. Click here for
                more details.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6 order-md-2 offset-1">
              <img
                className="img-fluid"
                src="./img/graphic-venue-activities.webp"
                alt="Activities"
              />
            </div>
            <div className="col-4 order-md-1 px-0 offset-1">
              <h2 className="color-purple mb-3">Activities</h2>
              <p>
                Guests can rent a bike to explore the grounds, relax at one of
                eight different pools, enjoy a memorable round of golf, join a
                tennis or pickleball clinic, or hop the resort's daily beach
                shuttle to Carlsbad Village and Moonlight Beach — with a
                supervised kids camp onsite for those bringing family.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6">
              <img
                className="img-fluid"
                src="./img/graphic-venue-golf.webp"
                alt="Golf"
              />
            </div>
            <div className="col-4 px-0 offset-1">
              <h2 className="color-purple mb-3">Golf</h2>
              <p>
                The resort's North and South Championship Courses offer one of
                the premier tee-time experiences in Southern California. The
                redesigned North Course now hosts the NCAA Division I Golf
                Championships and, for over 30 years, the courses served as a
                regular PGA TOUR stop.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6 order-md-2 offset-1">
              <img
                className="img-fluid"
                src="./img/graphic-venue-spa.webp"
                alt="Spa"
              />
            </div>
            <div className="col-4 order-md-1 px-0 offset-1">
              <h2 className="color-purple mb-3">Spa</h2>
              <p>
                The newly refreshed Spa at La Costa features an outdoor pool,
                waterfall showers, and a dedicated spa café, making it a full
                retreat available right between sessions. Call the spa directly
                to make an appointment at (760) 438-9111. Advance booking is
                recommended.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6">
              <img
                className="img-fluid"
                src="./img/graphic-venue-dining.webp"
                alt="Dining"
              />
            </div>
            <div className="col-4 px-0 offset-1">
              <h2 className="color-purple mb-3">Dining</h2>
              <p>
                The resort features multiple dining venues, from the
                award-winning Bob's Steak & Chop House to the breezy patio at
                VUE and Spanish-inspired Bar Traza, ensuring there's an option
                for every appetite and occasion. You can also have fun making
                s’mores with other attendees at a private fire pit!
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="text-center"></div>
      <section className="pt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-10 px-0">
              <div
                className="video-card"
                role="button"
                onClick={() => openOverlay("-ZitVNrxtJg")}
              >
                <img
                  className="img-fluid"
                  src="./img/graphic-venue-videostill.webp"
                  alt="Venue Video"
                />
                <div className="icon">
                  <i className="fa fa-play"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <VideoModal isOpen={isOpen} videoId={videoId} onClose={closeOverlay} />

      <RegisterCallout className="bg-before-white" />
    </>
  );
}
